import { NextSteps } from '@/pages/GetStarted/data';

export function NextStepsCard() {
  return (
    <div className="rounded-xl border border-grid bg-paper p-6 sm:p-8">
      <h2 className="text-xl font-bold text-graphite">{NextSteps.title}</h2>
      <ol className="mt-6 space-y-5">
        {NextSteps.steps.map((step, stepIndex) => (
          <li key={step.title} className="flex gap-4">
            <span
              aria-hidden="true"
              className="flex size-8 shrink-0 items-center justify-center rounded-full border-2 border-redline text-sm font-bold text-redline"
            >
              {stepIndex + 1}
            </span>
            <div>
              <h3 className="font-semibold text-graphite">{step.title}</h3>
              <p className="mt-1 text-[0.9375rem] leading-relaxed text-steel">{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}